import { render, staticRenderFns } from "./PrecioPromocion.vue?vue&type=template&id=7ae86a4f&scoped=true&"
import script from "./PrecioPromocion.vue?vue&type=script&lang=js&"
export * from "./PrecioPromocion.vue?vue&type=script&lang=js&"
import style0 from "./PrecioPromocion.vue?vue&type=style&index=0&id=7ae86a4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae86a4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
